import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const CareConfigurationAPI = {
	getConfigurations: () => {
		return axios.get(`${apiUrl}/careconfigurations`)
			.then((response) => response.data as CareConfigurationDTO[]);
	},
	getCareConfigurationVersions: (careConfigurationId?: number) => {
		return axios.get(`${apiUrl}/careconfigurations/${careConfigurationId}/careconfigurationversions`)
			.then((response) => response.data as CareConfigurationVersionDTO[]);
	},
}

export default CareConfigurationAPI;